import './style.scss'
import { ProgramSpoilerInit } from './ProgramSpoiler/ProgramSpoiler'
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'
import { createElement, render } from '../../../js/utils/render'
import { ClassName } from '../../../js/Form/const'

export default !function () {
  const block = document.querySelector('.program-v7')

  if (!block) {
    return
  }

  const blockName = block.closest('[data-block-name]')?.dataset.blockName ?? 'Блок без названия'
  const downloadButton = block.querySelector('.program-v7__button')

  if (downloadButton) {
    downloadButton.classList.remove(ClassName.LOADING)
    downloadButton.removeAttribute('inert')

    const openModalHandler = (evt) => {
      evt.preventDefault()

      const formSuccessHandler = () => {
        const successMessageBlock = orderModal?.element.querySelector('.message__success')
        const isSafari = /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent)
        const isIos = (/iPhone|iPad|iPod/.test(navigator.userAgent))

        // такая реализация по причине блокировки всплывающих окон в safari MacOS и iOS
        if (!(isSafari && isIos)) {
          const link = document.createElement('a')
          link.href = downloadButton?.href
          link.target = '_blank'
          link.rel = 'noopener noreferrer'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          setTimeout(() => {
            window.location.href = downloadButton?.href
          }, 1000)
        }

        render(successMessageBlock, createElement(
          `<a
            class="ui-link f f--12"
            style="margin-top: 6px"
            target="_blank"
            href="${downloadButton?.href}"
          >
            Нажмите сюда, чтобы открыть программу в PDF
          </a>`
        ))

        orderModal.form.removeEventListener('form-success', formSuccessHandler)
      }

      const orderModal = showOrderModal({
        isCenter: false,
        header: {
          title: 'Получите программу курса в PDF и бесплатную консультацию',
          description: 'Наш специалист свяжется с вами и ответит на все вопросы по программе',
          position: 'left'
        },
        button: {
          text: 'Получить программу в PDF'
        },
        blockName,
        closeHandler: () => orderModal?.form.removeEventListener('form-success', formSuccessHandler)
      })

      if (!orderModal) {
        return
      }

      orderModal.form.dataset.gtm = ''
      orderModal.form.dataset.formType = ''
      orderModal.form.dataset.redirectType = ''

      orderModal.form.addEventListener('form-success', formSuccessHandler)
    }

    downloadButton.addEventListener('click', openModalHandler)
  }

  ProgramSpoilerInit()
}();
